
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/leadersflipcards",
      function () {
        return require("private-next-pages/leadersflipcards.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/leadersflipcards"])
      });
    }
  